import script from "./SearchTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTab.vue?vue&type=script&setup=true&lang=js"

import "./SearchTab.vue?vue&type=style&index=0&id=ce7b02c2&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce7b02c2"]])

export default __exports__